export const ACTION_GET_REQUESTING = "ACTION_GET_REQUESTING";
export const ACTION_GET_SUCCESS = "ACTION_GET_SUCCESS";
export const ACTION_GET_ERROR = "ACTION_GET_LIST_ERROR";
export const ACTION_SET_BEST = "ACTION_SET_BEST";
export const ACTION_GET_ALL_LIST_REQUESTING = "ACTION_GET_ALL_LIST_REQUESTING";
export const ACTION_GET_ALL_LIST_SUCCESS = "ACTION_GET_ALL_LIST_SUCCESS";
export const ACTION_GET_ALL_LIST_ERROR = "ACTION_GET_ALL_LIST_ERROR";
export const ACTION_CHECK = "ACTION_CHECK";
export const ACTION_GET_SELECTION_LIST_REQUESTING =
  "ACTION_GET_SELECTION_LIST_REQUESTING";
export const ACTION_GET_SELECTION_LIST_SUCCESS =
  "ACTION_GET_SELECTION_LIST_SUCCESS";
export const ACTION_GET_SELECTION_LIST_ERROR =
  "ACTION_GET_SELECTION_LIST_ERROR";
export const ACTION_UPDATE_SELECTION_REQUESTING =
  "ACTION_UPDATE_SELECTION_REQUESTING";
export const ACTION_UPDATE_SELECTION_SUCCESS =
  "ACTION_UPDATE_SELECTION_SUCCESS";
export const ACTION_UPDATE_SELECTION_ERROR = "ACTION_UPDATE_SELECTION_ERROR";
export const ACTION_SELECT_TAB = "ACTION_SELECT_TAB";
export const ACTION_CLOSE_SNACK_MESSAGE = "ACTION_CLOSE_SNACK_MESSAGE";
export const ACTION_CREATION_MODIFY = "ACTION_CREATION_MODIFY";
export const ACTION_CREATE_REQUESTING = "ACTION_CREATE_REQUESTING";
export const ACTION_CREATE_SUCCESS = "ACTION_CREATE_SUCCESS";
export const ACTION_CREATE_ERROR = "ACTION_CREATE_ERROR";
export const ACTION_DELETE_PRIVATE_REQUESTING =
  "ACTION_DELETE_PRIVATE_REQUESTING";
export const ACTION_DELETE_PRIVATE_SUCCESS = "ACTION_DELETE_PRIVATE_SUCCESS";
export const ACTION_DELETE_PRIVATE_ERROR = "ACTION_DELETE_PRIVATE_ERROR";
export const ACTION_MODIFY_PRIVATE_REQUESTING =
  "ACTION_MODIFY_PRIVATE_REQUESTING";
export const ACTION_MODIFY_PRIVATE_SUCCESS = "ACTION_MODIFY_PRIVATE_SUCCESS";
export const ACTION_MODIFY_PRIVATE_ERROR = "ACTION_MODIFY_PRIVATE_ERROR";
export const ACTION_GET_PRIVATE_REQUESTING = "ACTION_GET_PRIVATE_REQUESTING";
export const ACTION_GET_PRIVATE_SUCCESS = "ACTION_GET_PRIVATE_SUCCESS";
export const ACTION_GET_PRIVATE_ERROR = "ACTION_GET_PRIVATE_ERROR";
export const ACTION_GET_SELECTED_REQUESTING = "ACTION_GET_SELECTED_REQUESTING";
export const ACTION_GET_SELECTED_ERROR = "ACTION_GET_SELECTED_ERROR";
export const ACTION_GET_SELECTED_SUCCESS = "ACTION_GET_SELECTED_SUCCESS";
